import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import MobileFooter from '../../../components/MobileFooter';

import {
  triggerUpdateRightSidebar,
} from '../../../modules/rightSidebar/actions';

import {
  toggleNavigation,
} from '@xanadu/ui-shared/modules/navigation/actions';

const mapDispatchToProps = {
  updateRightSidebar: triggerUpdateRightSidebar,
  toggleNavigation
};

function mapStateToProps(state) {
  return {
    sidebarContent: state.getIn(['rightSidebar', 'content']),
    sidebarVisible: state.getIn(['rightSidebar', 'visible']),
    navigationVisible: state.getIn(['navigation', 'navigationVisible']),
    balance: state.getIn(['user', 'balance']),
    edgeStatus: state.getIn(['application', 'edgeStatus']),
    sideBarVisible: state.getIn(['rightSidebar', 'visible'], ''),
    product: state.getIn(['application', 'product']),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MobileFooter));
